import { BaseModule } from "./base.module";

/**
 * An adapter for bridging existing custom javascript events on the one side, and cookiebot events on the other side
 */
export class CookieAdapterModule extends BaseModule {

    initialize() {
        this.setEventListeners();
    }

    setEventListeners() {
        window.addEventListener('CookiebotOnAccept', (event) => {
            if (Cookiebot.consent.marketing) {
                this.triggerEventOnElement('non-functional-cookies-accepted', document);
            }
        });
    }
}